import { ref } from "vue";

const title = ref("");
const subtitle = ref("");
const showMore = ref(false);
const showShare = ref(false);
const showDownload = ref(false);
// The current route's project record. On the project page this backs the
// "..." menu (Edit/Duplicate/Delete/Reject Share) — Project.vue sets it to
// the same object reference it keeps locally, so ProjectCardMenu's in-place
// mutations on rename stay in sync without any extra plumbing. On the
// document viewer there's no such menu, but Document.vue still sets it (name
// + isSingleton only) so the Share button knows whether to show the parent
// project's name or fall back to the document's own (see TopBar.vue's
// onShareClick). null on routes with neither use case.
const project = ref(null);
// The open document's record (document viewer only) — backs the header's
// "..." DocumentCardMenu. Same object Document.vue holds, so the menu's
// in-place mutations (rename, star) show up there too.
const openDocument = ref(null);
// Gate the two download options inside the download popover — set once the
// document's permissions are known (see Document.vue), separately from
// showDownload so the button doesn't flash options the user can't use.
const canDownloadAnnotated = ref(false);
const canDownloadOriginal = ref(false);

export function useTopBar() {
  function set(opts = {}) {
    title.value = opts.title ?? "";
    subtitle.value = opts.subtitle ?? "";
    showMore.value = !!opts.showMore;
    showShare.value = !!opts.showShare;
    showDownload.value = !!opts.showDownload;
    canDownloadAnnotated.value = !!opts.canDownloadAnnotated;
    canDownloadOriginal.value = !!opts.canDownloadOriginal;
    project.value = opts.project ?? null;
    openDocument.value = opts.openDocument ?? null;
  }
  return { title, subtitle, showMore, showShare, showDownload, canDownloadAnnotated, canDownloadOriginal, project, openDocument, set };
}
